import AbstractPageBaseController from '../../../../modules/core/abstracts/controllers/page-controller';

export default class BillingPositionsAbstractEditorController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.navHelper = this.injector.get('NavHelper');
        this.stateParams = this.injector.get('$stateParams');
        this.state = this.injector.get('$state');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');

        this.model = {
            title: '',
            description: '',
            category_id: null,
            label: '',
            price_per_unit: 0,
            service_fee_per_unit: 0,
            unit: '',
            fibu_account: '',
            fibu_tax_group: ''
        };
        this.loading = true;
        this.categories = [];
        this.submitting = false;
    }

    $onInit() {
        this._loadCategories();
    }

    _loadCategories() {
        this.api
            .post(
                'fp/billing/positions/categories',
                {
                    fields: [
                        'title',
                        'id'
                    ]
                }
            )
            .then(({data}) => {
                this.categories = [{
                    id: null,
                    title: 'no one'
                }];
                _.each(data.data, (cat) => {
                    this.categories.push(cat);
                })
            })
    }

    save(form) {
        if (!form.$valid) {
            angular.forEach(form.$error, function (field) {
                angular.forEach(field, function(errorField){
                    errorField.$setTouched();
                })
            });
            return;
        }
        this.submitting = true;

        this.doSave();
    }

    doSave() {
        console.log('do save not implemented');
    }

    cancel() {
        if (this.stateParams.store) {
            this.stateParams.store.dispatch('getData');
        }
        this.state.go('app.billing.positions.index');
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/positions/controllers/abstract-editor-controller.js